import { getDateTime } from "../../../utility/dateUtils";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LiveBackground from "../../liveBackground/LiveBackground";
import { configLeap3, drawingV2, slotConfs } from "../../../constant/initDrawing";
import Welcome from "../../live2/Welcome";
import _ from "lodash";
import LayoutWrapper from "../../live2/mt/LayoutWrapper";
import ContentWrapper from "../../live2/tc/ContentWrapper";
import RanderSlot from "../../live2/kp/RenderSlot";
import RandomQuestion from "../../results/randomQuestion";


const post = ["B", "F", "C", "I", "D", "N"];

const config = configLeap3;

const NumberNoSign = ({ num }) => {
    if (num.includes("?") || num.includes("*")) return ""
    return num;
}


const RenderRow = ({ row, i }) => {
    if (i > 0) {
        return <div className="row">
            {row.map((num, j) => {
                return <div style={{ ...config.style[`row_${i}_child`], fontSize: "45px" }} key={j}
                    className={`p-0 col-${config.iToCol[i]}`}>
                    <RenderItem num={num} i={i} j={j} />
                </div>
            })}
        </div>
    }
    return <RenderItem num={row} i={i} j={-1} />;
}

const RenderItem = ({ num, i, j }) => {
    if (i === 0 || i === 2) {
        return <div className="d-flex justify-content-center align-items-center h-100 w-100">
            <div style={config.style[`row_${i}_child_num`]}>
                <span style={config.style.postLabel}>{j === -1 ? "A" : post[j]}</span>
                <span style={{
                    padding: "0 10px"
                }}> = <RenderNumber num={num} /></span>
            </div>
        </div>
    }
    return <RenderNumber num={num} />;
}

const RenderNumber = ({ num }) => {
    let val = Array.isArray(num) ? num[0] : num;
    if (val.includes("*")) {
        return null;
    } else if (val.includes("?")) {
        return <RandomQuestion style={slotConfs.random} sizeDigit={val.length} />
    } else return val
}

const RenderResultItem = ({ item }) => {
    return <div style={config.style.resultItem} className="d-flex align-items-center">
        <div style={config.style.resultChild}>
            <NumberNoSign num={item.slice(-4)} />
        </div>
        <div style={{ ...config.style.resultChild, ...config.style.result3d }}>
            <NumberNoSign num={item.slice(-3)} />
        </div>
        <div style={config.style.resultChild}>
            <NumberNoSign num={item.slice(-2)} />
        </div>
    </div>
}

const Live3Leap = ({ socket }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isV4 = location.pathname.startsWith("/live-v4/");
    const [result, setResult] = useState(drawingV2);
    const [currentResult, setCurrentResult] = useState(drawingV2);

    useEffect(() => {
        const setPayload = (payload) => {
            setCurrentResult(payload);
            if (result.results.length === 0 || result.isInited) {
                setResult(payload)
            }
        }
        socket.on(`leap5d_result`, (payload) => {
            setPayload(payload);
        });
        socket.on(`leap6d_result`, (payload) => {
            setPayload(payload);
        });

        return () => {
            socket.off(`leap5d_result`);
            socket.off(`leap6d_result`);
        }
    }, [socket, result]);

    const onStartDraw = (result) => {
        setResult(result)
    }

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw} />

    const onAfterReleaseCallback = () => setResult(currentResult);


    return <LiveBackground result={result} variant={isV4 ? "v4" : undefined}
        preserveInnerBackgrounds={isV4} className="d-flex justify-content-center overflow-hidden mt-2 live2-leap" id="live3">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(isV4 ? "/live-v4" : "/live-v3")}
        >
            Back
        </button>
        <div>
            {!isV4 && <div className="d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    Leap
                </span> {getDateTime(result?.drawAt)}</div>}

            <LayoutWrapper>
                <ContentWrapper isDef shift="day" type="leap" >
                    <div className="d-flex position-relative" style={{
                        width: "100%",
                        height: "655px",
                    }}>
                        <div style={config.style.container}>
                            <table className="table-responsive h-100 p-0 m-0 overflow-hidden w-100">
                                <tbody className="h-100">
                                    {result.results.map((row, i) => {
                                        const lg = row[0]?.length > 0 ? row[0]?.length : 5;
                                        if (i === 2) return null;
                                        if (i === 0) return <tr key={i} className="h-100">
                                            <td style={config.style[`row_${i}`]}>
                                                <RanderSlot
                                                    digit={lg}
                                                    currentResult={currentResult}
                                                    index={0}
                                                    isNight={true}
                                                    onAfterReleaseCallback={onAfterReleaseCallback}
                                                    config={slotConfs}
                                                />
                                            </td>
                                        </tr>;
                                        return <tr key={i} className="h-100">
                                            <td id="live3-tb-padding" style={config.style[`row_${i}`]} align="middle"
                                                className="w-100 h-100 border-tran">
                                                <RenderRow row={row} i={i} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div style={{
                            // top: "0px", right: "55px",
                            width: "50%",
                            // height: "666px",
                        }} className="d-flex justify-content-center align-items-center">
                            <div style={{ height: "640px", marginLeft: "200px" }}>
                                {_.map(config.postToIndex, (value, key) => {
                                    const postsAll = [...result.results[0], ...result.results[2]];
                                    const item = postsAll[value]
                                    return <RenderResultItem key={key} item={item} />
                                })}
                            </div>
                        </div>

                    </div>
                </ContentWrapper>

            </LayoutWrapper>


        </div>
    </LiveBackground>
}

export default Live3Leap;
